import { VariableSourceType } from './VariableSourceType';
import { GspCommonDataType } from '../../../common-data-type/index';
import { CommonVariable } from './CommonVariable';

/**
 * 变量实体定义
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 变量实体定义
 */
export class CommonVariableEntity extends GspCommonDataType {

  /**
   * 变量集合
   */
  ContainElements: CommonVariable[];
}
